import { useParams, useSearchParams } from 'react-router-dom';
import { LockKeyhole } from 'lucide-react';
import { getWSServerUrl } from '@/lib/environment';

export function SsoLandingPage() {
  const { ssoToken } = useParams();
  const [searchParams] = useSearchParams();
  const forceLogin = searchParams.get('forceLogin') === '1';

  function continueWithSso() {
    if (!ssoToken) return;
    const query = forceLogin ? '?forceLogin=1' : '';
    window.location.href = `${getWSServerUrl()}/api/auth/workos/authorize/${encodeURIComponent(ssoToken)}${query}`;
  }

  return (
    <main className="login-page">
      <section className="login-shell sso-shell">
        <div className="login-card">
          <div className="sso-badge">
            <LockKeyhole size={20} />
          </div>
          <h1>Continue with Single Sign-On</h1>
          <p className="muted">
            Lantern will redirect you to your organization identity provider to complete sign-in.
          </p>
          <button type="button" className="primary-button" onClick={continueWithSso}>
            Continue
          </button>
        </div>
      </section>
    </main>
  );
}
